import React, { useEffect, useState } from 'react';
import GeneralPaymentRecieved from './components/generalPaymentRecieved';
import FieldCustomisationPaymentRecieved from './components/fieldCustomPaymentRecieved';
import SettingHeaderComponent from '../../components/settingHeaderComponent';
import { useSearchParams } from 'react-router-dom';

export default function SettingsPaymentReceived({ activeTab }) {
	const [searchParams, setSearchParams] = useSearchParams();
	const [tab, setTab] = useState('General');
	const [isEdit, setIsEdit] = useState(false);
	const [isCreateForm, setIsCreateForm] = useState(false);
	const [loader, setLoader] = useState(false);
	const [customFieldError, setCustomFieldError] = useState(false);
	const [error, setError] = useState(false);
	const [customFieldForm, setCustomFieldForm] = useState({
		label_name: '',
		data_type: '',
		status: false,
		is_mandatory: false,
	});
	const [form, setForm] = useState({
		allow_editing_sales_invoice: true,
		invoice_password: '',
		enable_qr_code_invoice: false,
		payment_notification_to_owner: false,
		payment_received_notification_to_customer: false,
		terms_and_conditions: '',
		customer_notes: '',
	});

	const handleGeneral = () => {};
	const handleCustomField = () => {};

	const setUrlSearchParams = () => {
		const url = new URLSearchParams();
		if (tab === 'General') {
			url.set('type', 'payment-received-general');
		} else {
			url.set('type', 'field-customisation');
		}
		setSearchParams(url);
	};

	useEffect(() => {
		setUrlSearchParams();
	}, [tab]);

	const setFilterFromUrl = () => {
		setTab(searchParams.get('type') === 'field-customisation' ? 'Field Customisation' : 'General');
	};

	useEffect(() => {
		setFilterFromUrl();
	}, []);

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				buttons={
					tab === 'Field Customisation'
						? [
								{
									id: 1,
									button: 'Add New Custom Field',
									add: true,
									close: false,
									disabled: false,
									handler: () => {
										setIsCreateForm(true);
									},
									className: 'btn-primary',
								},
							]
						: [
								{
									id: 1,
									disabled: !isEdit || loader,
									className: 'btn-primary',
									add: false,
									close: false,
									button: 'Save',
									loader: loader,
									handler: () => {
										handleGeneral();
									},
								},
								isEdit && {
									id: 2,
									disabled: false,
									className: 'btn-primary',
									add: false,
									close: false,
									button: 'Undo Changed',
									handler: () => {
										setIsEdit(false);
									},
								},
							].filter((button) => button !== false)
				}
			/>
			<div
				className="py-2 d-flex justify-content-between align-items-center"
				style={{ backgroundColor: '#DADDEC', position: 'sticky', top: 0, zIndex: 100 }}
			>
				<div>
					<ul className="nav mt-2">
						{['General', 'Field Customisation'].map((item, index) => (
							<li
								key={index}
								className="nav-item"
							>
								<div
									className={`tab-link ${tab === item ? 'active' : ''} d-flex align-items-center`}
									onClick={() => {
										setTab(item);
										setIsCreateForm(false);
									}}
								>
									{item}
								</div>
							</li>
						))}
					</ul>
				</div>
				{isCreateForm && (
					<div className="d-flex gap-4 align-items-center px-2">
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#0066ff' }}
							onClick={() => handleCustomField()}
						>
							Save
						</div>
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#555B67' }}
							onClick={() => setIsCreateForm(false)}
						>
							Cancel
						</div>
					</div>
				)}
			</div>
			{tab === 'General' ? (
				<GeneralPaymentRecieved
					form={form}
					setForm={setForm}
					error={error}
					setError={setError}
				/>
			) : (
				<FieldCustomisationPaymentRecieved
					isCreateForm={isCreateForm}
					setIsCreateForm={setIsCreateForm}
					setCustomFieldForm={setCustomFieldForm}
					customFieldForm={customFieldForm}
					setCustomFieldError={setCustomFieldError}
					customFieldError={customFieldError}
				/>
			)}
		</div>
	);
}
